import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ToolbarButtons from './ToolbarButtons';


class DocketsPaginator extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const {
      total_pages,
      visibleDocketNums,
      selectedPageNum,
      changePage,
      case_uuid,
      court_code,
      case_number,
      hasToolbar,
      toggleHeader,
      onPopupClick,
      getDocketParts,
      updateDocketParts,
    } = this.props;

    const numPages = Math.ceil(total_pages);
    const pageRange = _.range(numPages);
    const nextPage = selectedPageNum + 1;
    const prevPage = selectedPageNum - 1;
    const lastPage = pageRange[pageRange.length - 1] + 1;

    const max = 6;

    const pageIconCount = (numPages <= max)
      ? numPages
      : max;

    let paginatorItems = _.range(pageIconCount);

    if (selectedPageNum < max) {
      // take 1-9 + numPages
      paginatorItems = paginatorItems.map((el, idx) => {
        if (idx === paginatorItems.length - 1) {
          return numPages;
        }
        return idx + 1;
      });
    } else if (selectedPageNum >= numPages - (max + 2)) {
      // 1 + take currPage - max   (ex: 14)
      // 1 + take curr Page - max  (ex 10) with 12
      paginatorItems = paginatorItems.map((el, idx) => {
        if (idx === paginatorItems.length - 1) {
          return 1;
        }
        return selectedPageNum - idx;
      }).reverse();
    } else {
      // ex case 13
      // 1.. (1-4 range) currPage (1-4 range)..max
      // 1,...  9, 10, 11, 12, 13, 14, 15, 16, 17, ..22
      paginatorItems = paginatorItems.map((el, idx) => {
        if (idx === 0) {
          return 1;
        }
        if (idx === paginatorItems.length - 1) {
          return numPages;
        }
        return (selectedPageNum + idx) - 3;
      });
    }

    paginatorItems = paginatorItems.reduce((accum, el, idx) => {
      const key = `paginator-item${idx}`;
      const item = { page: el, active: (selectedPageNum === el) };
      const clsName = (item.active)
        ? 'active item'
        : 'item';

      if (idx !== 0 && paginatorItems[idx - 1] !== paginatorItems[idx] - 1) {
        return accum.concat([
          <span className="item ellipse" key={`${key}-ellipse`}>...</span>,
          <span
            key={key}
            className={clsName}
            onClick={() => {
              changePage({}, { page: el - 1, page_index: el });
            }}>
            { el }
          </span>,
        ]);
      }
      return accum.concat([
        <span
          key={key}
          className={clsName}
          onClick={() => {
            changePage({}, { page: el - 1, page_index: el });
          }}>
          { el }
        </span>,
      ]);
    }, []);

    const paginator = paginatorItems;

    return (
      <div className="docket-pagination">
        <div className="ui small borderless menu" id="docket-toolbar">
          {hasToolbar &&
            <ToolbarButtons
              visibleDocketNums={visibleDocketNums}
              case_uuid={case_uuid}
              court_code={court_code}
              case_number={case_number}
              onPopupClick={onPopupClick}
              toggleHeader={toggleHeader}
              updateDocketParts={updateDocketParts}
              getDocketParts={getDocketParts}
            />
          }

          <div className={`item ${(selectedPageNum === 1) ? 'disabled' : ''}`}
               title="Go to previous page"
               onClick={() => {
                 if (selectedPageNum !== 1) {
                   changePage({}, { page: prevPage - 1, page_index: prevPage });
                 }
               }}>
            ←
          </div>

          { paginator }
          { numPages > 1 &&
          <div className="view-all item"
               onClick={changePage.bind(null, {}, { page_index: 0, page_size: 2500 })}>
            View all
          </div>
          }

          <div className={`item ${(selectedPageNum === lastPage) ? 'disabled' : ''}`}
               title="Go to next page"
               onClick={() => {
                 if (selectedPageNum !== lastPage) {
                   changePage({}, { page: selectedPageNum, page_index: nextPage })
                 }
               }}>
            →
          </div>
        </div>
      </div>
    );
  }
}

DocketsPaginator.defaultProps = {
  hasToolbar: false,
};

DocketsPaginator.propTypes = {
  total_pages: PropTypes.number.isRequired,
  visibleDocketNums: PropTypes.array.isRequired,
  case_uuid: PropTypes.string.isRequired,
  selectedPageNum: PropTypes.number.isRequired,
  changePage: PropTypes.func.isRequired,
  toggleHeader: PropTypes.func.isRequired,
  onPopupClick: PropTypes.func.isRequired,
  hasToolbar: PropTypes.bool,
};

export default DocketsPaginator;



// WEBPACK FOOTER //
// ./src/components/case/docket/DocketsPaginator.jsx